export default __webpack_public_path__ + "static/media/bubble_right.ae636689.svg";